import React, { useEffect } from "react"
import Loader from "../../Helper/Loaders/Loader"
import { usePageMeta } from "../../Hooks/usePageMeta"
import { BatteryHealthLoaderBox, PageContainer } from "../../Components/CustomBox"
import { NotificationProvider } from "../../Hooks/useNotification"
import AlertDrillDownMain from "./AlertDrillDownMain"
import { decryptTheParams } from "../../Helper/QueryParams/EncryptDecrypt"

function AlertDrillDown(props) {
  const { pagesContent } = usePageMeta("alertDrillDown");
  const queryParams = decryptTheParams()

  useEffect(() => {
    pagesContent["mounted"] = true
  }, [pagesContent])

  return (
    <PageContainer>
      {(pagesContent?.mounted && queryParams?.chartName) ? (
        <NotificationProvider>
          <AlertDrillDownMain pagesContent={pagesContent} />
        </NotificationProvider>
      ) : (
        <BatteryHealthLoaderBox>
          <Loader />
        </BatteryHealthLoaderBox>
      )}
    </PageContainer>
  )
}

export default AlertDrillDown
